<div class="custom-input-container" [ngClass]="[size, error ? 'error' : '']">
    @if (label) {
        <label class="input-label">{{ label }}@if (isRequired) {<span class="required-mark" aria-hidden="true">*</span>}</label>
    }

    <div class="password-wrapper" [class.with-icon]="icon">
        @if (icon) {
            <i class="pi pi-{{icon}} input-icon" [class.icon-right]="iconPosition === 'right'"></i>
        }
        <p-password
            [placeholder]="placeholder"
            [(ngModel)]="value"
            (input)="onInput($event)"
            (blur)="markAsTouched()"
            [feedback]="false"
            [toggleMask]="true"
            [disabled]="disabled"
            [autocomplete]="autocomplete"
            class="custom-password"
        ></p-password>
    </div>

    <!-- Error Message -->
    @if (error && errorMessage && !showTooltip) {
        <div class="error-message">{{ errorMessage }}</div>
    }

    @if (error && errorMessage && showTooltip) {
        <div class="error-message with-tooltip">
            <span class="error-text">{{ errorMessage }}</span>
            <app-tooltip [tooltipText]="tooltipHtml" [showDelay]="300" [hideDelay]="300">
                <lucide-icon name="Info" class="tooltip-icon"></lucide-icon>
            </app-tooltip>
        </div>
    }

    <!-- Helper Text -->
    @if (helperText) {
        <div class="helper-text">{{ helperText }}</div>
    }
</div>